<template>
  <el-table :data="domainGoalList">
    <el-table-column v-for="goal in goalsListInfo" :prop="goal.prop" :label="goal.label" :key="goal.prop"> </el-table-column>
    <el-table-column width="40">
      <template slot-scope="scope">
        <el-popover trigger="hover" placement="top" popper-class="goal-popover">
          <p>{{ lang('Goal:') }} {{ scope.row.PlnMasGoalsITL }}</p>
          <div slot="reference" class="goal-wrapper">
            <el-tag size="small">
              <K2Icon name="more" :font-size="uiVariable.fontSize.lg" :color="uiVariable.color.yellow" link="true" />
            </el-tag>
          </div>
        </el-popover>
      </template>
    </el-table-column>
    <el-table-column id="GoalLabels" label="" width="1px"> </el-table-column>

    <div class="Table" v-for="(ddlTermGoalList, index) in ddlTermGoalsLists">
      <PlannerTableColumn
        v-bind:goal-refresh="goalRefresh"
        v-bind:ddlTermGoalsList="ddlTermGoalsLists[index]"
        v-bind:ddlTermClassGoalsList="ddlTermClassGoalsLists[index]"
        v-bind:term="index"
        v-on:termGoalChangeColumn="termGoalChange"
        :disabled="studentMode"
      />
      <PlannerTableColumn
        v-bind:goal-refresh="goalRefresh"
        v-bind:ddlTermGoalsList="ddlStudentTermGoalsLists[index]"
        v-bind:ddlTermClassGoalsList="[]"
        v-bind:term="index"
        v-on:termGoalChangeColumn="studentTermGoalChange"
        v-if="studentMode"
        :classname="'studentCheck'"
      />
    </div>
  </el-table>
</template>

<script>
import K2ToolTip from '@/uiComponents/k2ToolTip/k2ToolTip'
import K2Icon from '@/uiComponents/k2Icon/k2MAIcon'
import K2Row from '@/uiComponents/k2Row/k2Row'
import uiVariable from '../../config/uiVariable'
import { lang } from '@/locale'
import PlannerTableColumn from '@/uiComponents/K2PlannerTable/PlannerTableColumn'

export default {
  name: 'PlannerTable',
  props: {
    domainGoalList: {
      type: Array,
    },
    goalRefresh: {
      type: Number,
    },
    ddlTerm1GoalsList: {
      type: Array,
    },
    ddlTerm2GoalsList: {
      type: Array,
    },
    ddlTerm3GoalsList: {
      type: Array,
    },
    ddlTerm4GoalsList: {
      type: Array,
    },
    ddlTermGoalsLists: {
      type: Array,
    },
    ddlTermClassGoalsLists: {
      type: Array,
    },
    ddlStudentTermGoalsLists: {
      type: Array,
    },
    studentMode: {
      type: Boolean,
    },
  },
  components: { K2ToolTip, K2Icon, K2Row, PlannerTableColumn },
  data() {
    return {
      uiVariable: uiVariable,
      domainGoalListz: this.domainGoalList,
      // domainGoalList: {},
      goalsListInfo: [
        {
          prop: 'PlnMasIndicator',
          label: '',
        },
      ],
    }
  },
  mounted() {
    this.goalsListInfo[0].label = lang('Goal Indicator')
  },
  methods: {
    lang,

    termGoalChange(value) {
      this.$emit('termGoalChange', value)
    },
    studentTermGoalChange(value) {
      this.$emit('studentTermGoalChange', value)
    },
  },
}
</script>

<style scoped></style>
